import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { IExtractServiceTask, IExtractTask } from '../types/IExtractTask';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISiteNameWithId } from '../types/ISiteNameWithId';
import { INamedItem, IPublishedConnectionWithTablesItem } from '../types/resourceParts';

export interface IGetExtractTasksResult extends IGetItemsResult {
  tasks: IExtractTask[];
  datasources?: INamedItem[];
  workbooks?: INamedItem[];
  schedules: ISchedule[];
  sites: ISiteNameWithId[];
  publishedConnections?: IPublishedConnectionWithTablesItem[];
  extractServiceTasks?: IExtractServiceTask[];
}

export class GetExtractTasksRequest extends Request<IGetItemsParams, IGetExtractTasksResult> {
  constructor(params: IGetItemsParams) {
    super('getExtractTasks', params);
  }
}
